import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
	Grid,
	TextField,
	MenuItem,
} from "@mui/material";
import CustomButton from "../../../../src/components/CustomButton/CustomButton";
import SearchIcon from "@mui/icons-material/Search";
import { resetbankNameList, bankNameList } from "../../../redux/actions/bankNameListAction";
import { resetbankBranchList, bankBranchList } from "../../../redux/actions/bankBranchListAction";
import { resetwithdrawEMoneyList, withdrawEMoneyList } from "../../../redux/actions/bankWithdrawEMoneyListAction";
import { resetwithdrawEMoneyApproveReject, withdrawEMoneyApproveReject } from "../../../redux/actions/bankWithdrawEMoneyApproveRejectAction";
import { Card,  Modal, ModalHeader, } from "reactstrap";

function WithdrawEMoneyFilter() {
	const [bankName, setbankName] = useState("");
    const [branchName, setbranchName] = useState("");
    const [bankCode, setbankCode] = useState("");

	const dispatch = useDispatch();
    const login = useSelector(({ login }) => login);
	const bankbranchlist = useSelector(({ bankBranchlist }) => bankBranchlist);
	const banknamelist = useSelector(({ bankNamelist }) => bankNamelist);
	const withdrawEMoneyApproveReject = useSelector(({ bankWithdrawEMoneyApproveReject }) => bankWithdrawEMoneyApproveReject);
    const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);


    const withdrawEMoneyRequest = () => {

        const req = {
            actionCustomerMasterRequestVO : {
                bankName,
                branchName,
                bankId : login.data.partnerId,
				adminId: "",
				role: "",
            }
        }

        console.log(req)

		if(regenerateTokenRes.success){
			dispatch(withdrawEMoneyList(req, regenerateTokenRes.data.AuthToken))
		}		
    }

    const getBankNamesRequest = () => {

        const req = {
            actionCustomerMasterRequestVO : {
                bankId : login.data.partnerId,
            }
        }

        console.log(req)

		dispatch(bankNameList(req, regenerateTokenRes.data.AuthToken));
    }

    const getBranchNamesRequest = () => {

        const req = {
            actionCustomerMasterRequestVO: {
                bankId : login.data.partnerId,
                bankCode,
            }
        }
        console.log(req)

		dispatch(bankBranchList(req, regenerateTokenRes.data.AuthToken));
    }

	const handleChange = ({ target: { value, name } }) => {
		
		if(name === "bankName"){
			setbankName(value);
			setbankCode((value.length && banknamelist.data.errorList.find((x) => x.name === value).code) || "")
		}

		if(name === "branchName"){
			setbranchName(value);
		}
	}

	useEffect(() => {
		if(withdrawEMoneyApproveReject.success){
            withdrawEMoneyRequest();
		}
	}, [withdrawEMoneyApproveReject])

    useEffect(() => {
        if(regenerateTokenRes.success){
            getBankNamesRequest();
            getBranchNamesRequest();
        }
    }, [bankCode, regenerateTokenRes.success])

	useEffect(() => {
		return () => {
			dispatch(resetbankNameList());
			dispatch(resetbankBranchList());
			dispatch(resetwithdrawEMoneyList());
			dispatch(resetwithdrawEMoneyApproveReject());
		}
	}, [])

  return (
	<>
    	<Card>
					<Grid
						container
						spacing={2}
						style={{ 
                            padding: "25px", 
                            // marginTop: "2rem" 
                        }}
					>
						<Grid item xs={12} sm={6} md={4} lg={4}>
							<TextField
								select
								size="small"
								color="primary"
								type="text"
								label="Bank Name"
								fullWidth={true}
								name="bankName"
								defaultValue={bankName}
								onChange={handleChange}
							>
								<MenuItem value="" selected="Select Bank Name">
									Select Bank Name
								</MenuItem>
								{banknamelist.success &&
									[]
										.concat(banknamelist.data.errorList)
										.map((x) => <MenuItem value={x.name}>{x.name}</MenuItem>)}
							</TextField>
						</Grid>
						<Grid item xs={12} sm={6} md={4} lg={4}>
							<TextField
								select
								size="small"
								color="primary"
								type="text"
								label="Branch Name"
								fullWidth={true}
								name="branchName"
								defaultValue={branchName}
								onChange={handleChange}
							>
								<MenuItem
									value=""
									selected="Select Branch Name"
								>
									Select Branch Name
								</MenuItem>
								{bankbranchlist.success &&
									[]
										.concat(bankbranchlist.data.errorList)
										.map((x) => <MenuItem value={x.name}>{x.name}</MenuItem>)}
							</TextField>
						</Grid>
						<Grid item xs={12} sm={6} md={4} lg={3}>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={withdrawEMoneyRequest}
							>
								Search <SearchIcon />
							</CustomButton>
						</Grid>
					</Grid>
				</Card>
				</>
  )
}

export default WithdrawEMoneyFilter